module.exports = __webpack_public_path__ + "static/media/ic_logo1.96baf2ba.png";